import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import DataGridBaseHeader from 'src/components/DataGrid/Base/DataGridBaseHeader';
import { Link } from 'react-router-dom';

const Title = styled('div')`
  font-size: var(--ph-heading-two);
  font-family: var(--ph-font-family-lato-regular);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  margin: 15px 54px;
`;

const Wrapper = styled('div')`
  margin: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

const DashboardContent = styled('div')`
  min-height: 100%;
  padding-top: 0;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
  flex: 1;
`;

const DashboardComponent = styled('div')`
  border-radius: var(--ph-border-radius-sm);
  background-color: rgba(var(--ph-gray-rgb-50), 0.5);
  padding: 15px;

  div[class*='Base-styles-Columns'] {
    margin: 0;
    border-radius: var(--ph-border-radius-sm);
    padding: 0 10px;
    position: relative;
    top: 0;
  }

  div[class*='DataGrid-styles-tableItems'] {
    padding: 10px;
    background-color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    box-shadow: var(--ph-box-shadow-sm);
    margin: 0;
  }

  div[class*='Base-styles-Item'] {
    padding: 8px 10px;
  }

  a[class*='Base-styles-Link'] {
    padding: 0;
  }

  a[class*='Base-styles-Link']:nth-child(even) {
    border-radius: var(--ph-border-radius-sm);
  }

  div[class*='DataGrid-styles-footer'] {
    padding: 30px 0 15px;
  }

  & + & {
    margin-top: 0;
  }
`;

const DashboardComponentTitle = styled('div')`
  text-transform: capitalize;
  font-size: var(--ph-heading-three);
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  margin-bottom: 15px;

  &.widget {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const WidgetDiv = styled('div')`
  display: flex;
  margin: 3px;
  flex-wrap: wrap;
`;

const WidgetCard = styled('div')`
  flex: 0 0 calc(33.333333% - 10px);
  margin-bottom: 10px;
  margin-right: 10px;
  overflow: hidden;
  box-shadow: var(--ph-box-shadow-sm);

  @media screen and (max-width: 900px) {
    flex: 0 0 calc(45.333333% - 10px);
  }

  @media screen and (max-width: 700px) {
    flex: 0 0 100%;
  }

  &.factory {
    flex: 0 0 50%;
  }
`;

const WidgetCardInnerDiv = styled('div')`
  padding: 20px;
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
  height: 100%;

  &.flex {
    display: flex;
  }
`;

const WidgetCardInnerFindingsDiv = styled('div')`
padding: 20px;
box-shadow: var(--ph-box-shadow-sm);
background-color: var(--white);

&.flex {
  display: flex;
}
`;

const WidgetCardInnerDivLeft = styled('div')`
  flex: 3;
  overflow: hidden;
`;
const WidgetCardInnerDivRight = styled('div')`
  flex: 2;
  overflow: hidden;
`;

const JobName = styled(Link)`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-heading-three);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 650px) {
    white-space: unset;
  }
`;

const FactoryName = styled('div')`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px 0;

  @media screen and (max-width: 1250px) {
    white-space: unset;
  }
`;

const ServicesName = styled('div')`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px 0;

  @media screen and (max-width: 1250px) {
    white-space: unset;
  }
`;

const DateAndAssignedTo = styled('div')`
  display: flex;
`;

const DateAndAssignedToLeft = styled('div')`
  flex: 1;
  overflow: hidden;
`;

const DateAndAssignedToRight = styled('div')`
  flex: 1;
  overflow: hidden;

  &.notAssigned {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

const ProgramName = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 10px 0;
`;

const CardSmallTitle = styled('div')`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 1250px) {
    white-space: unset;
  }
`;

const CardSmallValue = styled('div')`
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  line-height: 1.25;
  min-height: 1.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  margin-top: 10px;

  @media screen and (max-width: 1250px) {
    white-space: unset;
  }
`;

const AuditStartDate = styled('span')`
  margin: 10px 0;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);

  @media screen and (max-width: 1250px) {
    white-space: unset;
  }
`;

const ServiceButtonBookIcon = styled(Svg)`
  width: 20px;
  height: 20px;
  margin-right: 7px;
  top: 5px;
`;

const NotAssignedIcon = styled(Svg)`
  width: 50px;
  height: 50px;
  margin-right: 7px;
  top: 3px;
  pointer-events: none;
`;

const ProgramIcon = styled(Svg)`
  width: 20px;
  height: 20px;
  margin-right: 7px;
  top: 3px;
  pointer-events: none;
`;

const ErrorIcon = styled(Svg)`
  width: 10px;
  height: 10px;
  margin-right: 3px;
  font-size: var(--ph-text-sm);
`;

const NoRatingDataDiv = styled('div')`
  color: var(--ph-red-500);
`;

const Status = styled('div')`
  float: right;

  &.active td {
    font-weight: bold;
  }

  &.flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
`;

const PieChartDiv = styled('div')`
  width: 25px;
  height: 25px;
  position: relative;
`;

const PieChartText = styled('span')`
  position: absolute;
  font-size: var(--ph-text-xs);
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  top: 7px;
  font-weight: 600;
  letter-spacing: normal;
  color: var(--black);
`;

const CardInfoWithMargin = styled('div')`
  margin: 10px 0;
`;

const JobStatusSpan = styled('div')`
  padding: 5px 10px;
  display: inline-block;
  margin: 5px 5px 0 0;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-md);
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);

  &.underReview {
    background-color: var(--ph-dark-blue-500);
    color: var(--white);
  }

  &.readyForReview {
    background-color: var(--ph-yellow-500);
  }

  &.actionRequired {
    background-color: var(--ph-red-500);
    color: white;
  }

  &.notAssigned {
    background-color: var(--ph-red-500);
    color: white;
  }

  &.underCap {
    background-color: var(--ph-gray-500);
    color: white;
  }

  &.readyForCap {
    background-color: var(--ph-yellow-500);
  }

  &[saqJobStatus="readyForExternalSaq"] {
    background-color: var(--ph-yellow-500);
  }

  &[saqJobStatus="underExternalSaq"] {
    background-color: var(--ph-dark-blue-500);
    color: var(--white);
  }

  &[saqJobStatus="readyForInternalSaq"] {
    background-color: var(--ph-yellow-500);
  }

  &[saqJobStatus="underInternalSaq"] {
    background-color: var(--ph-dark-blue-500);
    color: var(--white);
  }

  & + & {
    margin-left: 5px;
  }
`;

const OrderByText = styled('span')`
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  float: right;
  margin-right: 10px;
`;

const BoxLine = styled('div')`
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border-top: solid 1px var(--ph-gray-500);
`;

const FindingStatusTitleText = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  margin: 10px 0;
`;

const FacilityScoreAndBenchmarking = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  margin: 10px 0;
`;

const BlockWithText = styled('div')`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--black);
  margin-bottom: 3px;
`;

const StatusSpan = styled('span')`
  height: 18px;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  border-radius: var(--ph-border-radius-sm);
  padding: 1px 6px;
  align-items: center;
  justify-content: center;
  margin: 10px 0 10px 0;

  & + & {
    margin-left: 5px;
  }

  &.pending {
    background-color: var(--ph-gray-500);
  }

  &.rejected {
    background-color: var(--ph-red-500);
  }

  &.approved {
    background-color: var(--ph-green-500);
    top: 0;
  }

  &.zero {
    background-color: var(--ph-gray-100);
  }

  &.factory {
    width: 42px;
    display: inline-block;
    padding: 0;
    text-align: center;
  }
`;

const FindingsDiv = styled('div')`
  margin: 5px;
  height: 328px;
`;

const StatusSvg = styled(Svg)`
  width: 10px;
  fill: var(--white);
  margin-right: 4px;
  top: 1px;
`;

const ResponsiblePersonTitle = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.69;
  letter-spacing: normal;
  color: var(--ph-gray-500);
`;

const ResponsiblePersonText = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: normal;
  color: var(--black);
  height: 27px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NoActionSpan = styled('div')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-gray-500);
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  width: 92px;
  padding: 4px 8px;
`;

const FindingDiv = styled('div')`
  & + & {
    margin-top: 20px;
  }
`;
const RatingGradeSpan = styled('span')`
  float: left;
  border-radius: var(--ph-border-radius-sm);
  color: var(--white);
  padding: 5px;
  font-size: var(--ph-text-lg);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;

const FactoryRatingInfoDiv = styled('div')`
  height: 30px;
`;

const RatingDataText = styled('div')`
  font-size: var(--ph-text-lg);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const RatingBarDiv = styled('div')`
  float: left;
  margin-left: 20px;
  width: 50%;
`;

const InnerDivRow = styled('div')`
  height: 35px;
  font-size: var(--ph-text-sm);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  line-height: 35px;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const JobsSummaryDiv = styled('div')`
  display: flex;
  border-radius: var(--ph-border-radius-sm);
  box-shadow: var(--ph-box-shadow-sm);
  background: var(--white);
  margin-bottom: 25px;
`;

const JobsSummaryInfoDiv = styled('div')`
  flex: 1;

  &.flex2 {
    flex: 2;
  }

`;

const JobsSummaryInfoTitle = styled('div')`
  background-color: rgb(var(--ph-gray-rgb-100));
  padding: 10px;
  object-fit: contain;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  font-family: var(--ph-font-family-lato-regular);
  text-transform: capitalize;
  letter-spacing: normal;
  color: var(--ph-gray-850);

  &:hover {
    background-color: var(--ph-gray-150);
  }
`;

const JobsSummaryInfoBigNumber = styled('div')`
  padding: 10px;
  object-fit: contain;
  font-size: var(--ph-heading-two);
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: var(--black);

  &.red {
    color: var(--ph-red-500);
  }
`;

const JobsSummaryLastReportRecord = styled('div')`
  display: flex;
  padding: 10px 10px 0;

  &:last-child {
    padding-bottom: 10px;
  }
`;

const JobsSummaryLastReportRecordLeft = styled(Link)`
  flex: 5;
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: var(--ph-light-blue-500);
`;

const JobsSummaryLastReportRecordRight = styled('div')`
  flex: 1;
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: right;
  color: var(--black);
`;

const JobsSummaryCountriesDiv = styled('div')`
  display: flex;
  padding: 10px;
`;

const JobsSummaryCountriesColumn = styled('div')`
  flex: 1;
`;

const JobsSummaryCountryRecord = styled('div')`
  display: flex;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const JobsSummaryCountryRecordLeft = styled('div')`
  flex: 4;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: var(--black);
`;

const JobsSummaryCountryRecordRight = styled('div')`
  flex: 1;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: var(--black);
`;

const JobsSummaryColumnFiltersDiv = styled('div')`
  margin: 10px 0;
`;

const HideOrShowFilter = styled('span')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sm);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;
  background-color: var(--transparent);
  color: var(--ph-gray-500);

  &:hover {
    background-color: var(--ph-gray-25);
    color: var(--ph-gray-700);
  }

  &:active {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-700);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const FiltersHeader = styled(DataGridBaseHeader)`
  margin-bottom: 15px;

  div[class*="MorePopup"] {
    z-index: 99;
  }
`;

const SaqJobsWidgetDiv = styled('div')`
  display: flex;
  margin: 3px;
  flex-wrap: wrap;
`;

const CornerNavigationContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
`;

const CornerNavigationIcon = styled('div')`
  cursor: pointer;

  &.inactive {
    cursor: auto;
    color: var(--ph-gray-200);
  }
`;

export default {
  Title,
  Wrapper,
  DashboardContent,
  DashboardComponent,
  DashboardComponentTitle,
  WidgetDiv,
  WidgetCard,
  WidgetCardInnerDiv,
  WidgetCardInnerFindingsDiv,
  JobName,
  FactoryName,
  ServicesName,
  CardSmallTitle,
  CardSmallValue,
  AuditStartDate,
  ProgramName,
  Text,
  ServiceButtonBookIcon,
  DateAndAssignedTo,
  DateAndAssignedToLeft,
  DateAndAssignedToRight,
  Status,
  PieChartText,
  PieChartDiv,
  CardInfoWithMargin,
  ProgramIcon,
  JobStatusSpan,
  OrderByText,
  NotAssignedIcon,
  BoxLine,
  FindingStatusTitleText,
  BlockWithText,
  StatusSvg,
  StatusSpan,
  FindingsDiv,
  ResponsiblePersonTitle,
  ResponsiblePersonText,
  NoActionSpan,
  FindingDiv,
  FacilityScoreAndBenchmarking,
  WidgetCardInnerDivLeft,
  WidgetCardInnerDivRight,
  RatingGradeSpan,
  FactoryRatingInfoDiv,
  RatingDataText,
  RatingBarDiv,
  InnerDivRow,
  JobsSummaryDiv,
  JobsSummaryInfoDiv,
  JobsSummaryInfoTitle,
  JobsSummaryInfoBigNumber,
  JobsSummaryLastReportRecord,
  JobsSummaryLastReportRecordLeft,
  JobsSummaryLastReportRecordRight,
  JobsSummaryCountriesDiv,
  JobsSummaryCountriesColumn,
  JobsSummaryCountryRecord,
  JobsSummaryCountryRecordLeft,
  JobsSummaryCountryRecordRight,
  JobsSummaryColumnFiltersDiv,
  HideOrShowFilter,
  ErrorIcon,
  NoRatingDataDiv,
  FiltersHeader,
  SaqJobsWidgetDiv,
  CornerNavigationContainer,
  CornerNavigationIcon
};
